import { batch } from 'react-redux'
import { makeActionCreator } from '../../config/store/utils'
import { sendParticipantDataEdited } from '../../services/participants'
import { onSetOpenToastSuccess } from '../UserNotificationToast/UserNotificationToast.actions'
import { ERROR_MESSAGE } from '../../config/settings/constants'

export const SET_EDIT_AUTO_MODAL_SHOW_SUCCESS = 'SET_EDIT_AUTO_MODAL_SHOW_SUCCESS'
export const onSetAutoEditModalShowSuccess = makeActionCreator(SET_EDIT_AUTO_MODAL_SHOW_SUCCESS, 'payload')

export const SET_EDIT_AUTO_MODAL_FUNCTION_SUCCESS = 'SET_EDIT_AUTO_MODAL_FUNCTION_SUCCESS'
export const onSetAutoEditModalFunctionSuccess = makeActionCreator(SET_EDIT_AUTO_MODAL_FUNCTION_SUCCESS, 'payload')

export const SET_EDIT_AUTO_START_DATE_SUCCESS = 'SET_EDIT_AUTO_START_DATE_SUCCESS'
export const onSetAutoEditStartDateSuccess = makeActionCreator(SET_EDIT_AUTO_START_DATE_SUCCESS, 'payload')

export const SET_EDIT_AUTO_END_DATE_SUCCESS = 'SET_EDIT_AUTO_END_DATE_SUCCESS'
export const onSetAutoEditEndDateSuccess = makeActionCreator(SET_EDIT_AUTO_END_DATE_SUCCESS, 'payload')

export const SEND_AUTO_PARTICIPANT_DATA_EDITED = 'SEND_AUTO_PARTICIPANT_DATA_EDITED'
export const SEND_AUTO_PARTICIPANT_DATA_EDITED_ERROR = 'SEND_AUTO_PARTICIPANT_DATA_EDITED_ERROR'
export const SEND_AUTO_PARTICIPANT_DATA_EDITED_SUCCESS = 'SEND_AUTO_PARTICIPANT_DATA_EDITED_SUCCESS'

export const onSendAutoParticipantDataEdited = makeActionCreator(SEND_AUTO_PARTICIPANT_DATA_EDITED)
export const onSendAutoParticipantDataEditedError = makeActionCreator(
  SEND_AUTO_PARTICIPANT_DATA_EDITED_ERROR,
  'payload'
)
export const onSendAutoParticipantDataEditedSuccess = makeActionCreator(
  SEND_AUTO_PARTICIPANT_DATA_EDITED_SUCCESS,
  'payload'
)

export const onSendAutoParticipantDataEditedThunk = payload => async dispatch => {
  dispatch(onSendAutoParticipantDataEdited())
  try {
    const { onSuccessCallback, ...rest } = payload
    await sendParticipantDataEdited({ body: rest, actionType: SEND_AUTO_PARTICIPANT_DATA_EDITED })
    return batch(() => {
      dispatch(
        onSetOpenToastSuccess({
          open: true,
          message: 'Participante editado con éxito',
          severity: 'success',
          handleClose: onSuccessCallback
        })
      )
    })
  } catch (error) {
    return batch(() => {
      dispatch(onSetOpenToastSuccess({ open: true, message: ERROR_MESSAGE, severity: 'error' }))
      dispatch(onSendAutoParticipantDataEditedError({ error }))
    })
  }
}
